type Props = {
	children: React.ReactNode;
};

export const InputImageWrapper = ({ children }: Props) => {
	return <div className="grid items-center gap-y-6">{children}</div>;
};
